// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"de","landingPageVideo":"ee","play":"fe","iframeVideo":"ge","playHidden":"he","playVisible":"ie","fullwidth":"je"};